import { SxProps, Theme } from '@mui/material';

export const AlertStyles: SxProps<Theme> = {
  color: '#fff',
  padding: theme => `${theme.spacing(1)} ${theme.spacing(2)}`,
  borderRadius: '5px',
  display: 'flex',
  alignItems: 'center',
  '&.error': {
    backgroundColor: '#e64033',
  },
  '&.success': {
    backgroundColor: '#53af50',
  },
};

export const AlertIconStyles: SxProps<Theme> = {
  display: 'flex',
  marginRight: theme => theme.spacing(1),
};
